import babyRouterMap from '@/router/modules/baby'

const maternalRouterMap = [
  {
    name: "身份校验",
    path: "/maternal/identitycheck",
    component: () => import("@/pages/maternal/identitycheck")
  },
  {
    name: "设置孕产信息",
    path: "/maternal/setduedate",
    component: () => import("@/pages/maternal/setduedate"),
    meta: {
      systemCode: 'setduedate',
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "设置",
    path: "/maternal/setduedateempty",
    component: () => import("@/pages/maternal/setduedateempty")
  },
  {
    name: "计算预产期",
    path: "/maternal/duedate",
    component: () => import("@/pages/maternal/duedate")
  },
  {
    name: "孕产妇首页",
    path: "/maternal/home",
    component: () => import("@/pages/maternal/home"),
    meta: {
      systemCode: 'yunchan',
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "孕期管理",
    path: "/maternal/pregnancylist",
    component: () => import("@/pages/maternal/pregnancylist")
  },
  {
    name: "孕期记录",
    path: "/maternal/pregnancyrecords",
    component: () => import("@/pages/maternal/pregnancyrecords")
  },
  {
    name: "科室选择",
    path: "/maternal/specialist",
    component: () => import("@/pages/maternal/specialist"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "专科门诊详情",
    path: "/maternal/specialist/detail",
    component: () => import("@/pages/maternal/specialistdetail"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "文章详情",
    path: "/maternal/article/detail",
    component: () => import("@/pages/maternal/articledetail")
  },
  {
    name: "个人中心",
    path: "/maternal/mine",
    component: () => import("@/pages/maternal/mine")
  },
  {
    name: "个人信息",
    path: "/maternal/info",
    component: () => import("@/pages/maternal/info")
  },
  {
    name: "修改昵称",
    path: "/maternal/editname",
    component: () => import("@/pages/maternal/editname")
  },
  {
    name: "意见反馈",
    path: "/maternal/feedback",
    component: () => import("@/pages/maternal/feedback")
  },
  {
    name: "关于我们",
    path: "/maternal/about",
    component: () => import("@/pages/maternal/about")
  },

  {
    name: "能不能吃首页",
    path: "/food/home",
    component: () => import("@/pages/food/home"),
    meta: {
      systemCode: 'food',
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "列表",
    path: "/food/list",
    component: () => import("@/pages/food/list"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "详情",
    path: "/food/detail",
    component: () => import("@/pages/food/detail")
  },
  {
    name: "提交新食物",
    path: "/food/submit",
    component: () => import("@/pages/food/submit")
  },
  {
    name: "产检助手",
    path: "/check/home",
    component: () => import("@/pages/check/home"),
    meta: {
      systemCode: 'check',
      isUseCache: true,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "产检详情",
    path: "/check/detail",
    component: () => import("@/pages/check/detail")
  },
  {
    name: "宝宝变化",
    path: "/babychange/home",
    component: () => import("@/pages/babychange/home"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "胎儿体重估算",
    path: "/babychange/submit",
    component: () => import("@/pages/babychange/submit")
  },
  {
    name: "胎儿体重估算结果",
    path: "/babychange/detail",
    component: () => import("@/pages/babychange/detail")
  },
  {
    name: "妈妈变化",
    path: "/mother/home",
    component: () => import("@/pages/mother/home"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "常见症状详情",
    path: "/mother/symptoms",
    component: () => import("@/pages/mother/symptoms"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "专家讲解",
    path: "/mother/expertsarticle",
    component: () => import("@/pages/mother/expertsarticle"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "知识详情",
    path: "/mother/article/detail",
    component: () => import("@/pages/mother/articledetail"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "体重首页",
    path: "/babyweight/home",
    component: () => import("@/pages/babyweight/home"),
    meta: {
      systemCode: 'babyweight'
    }
  },
  {
    name: "体重记录列表",
    path: "/babyweight/record",
    component: () => import("@/pages/babyweight/record"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "体重详情",
    path: "/babyweight/detail",
    component: () => import("@/pages/babyweight/detail")
  },
  {
    name: "记录体重",
    path: "/babyweight/submit",
    component: () => import("@/pages/babyweight/submit")
  },
  {
    name: "设置孕前体重身高信息",
    path: "/babyweight/beforeweight",
    component: () => import("@/pages/babyweight/beforeweight")
  },
  {
    name: "体重健康指导",
    path: "/babyweight/guide",
    component: () => import("@/pages/babyweight/guide")
  },
  {
    name: "数胎动首页",
    path: "/quickening/home",
    component: () => import("@/pages/quickening/home"),
    meta: {
      systemCode: 'quickening',
    }
  },
  {
    name: "数胎动历史记录",
    path: "/quickening/record",
    component: () => import("@/pages/quickening/record")
  },
  {
    name: "读懂报告单",
    path: "/readreport/home",
    component: () => import("@/pages/readreport/home"),
    meta: {
      systemCode: 'readreport',
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "知识库",
    path: "/knowledge/home",
    component: () => import("@/pages/knowledge/home"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "知识库",
    path: "/knowledge/list",
    component: () => import("@/pages/knowledge/list"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "知识库",
    path: "/knowledge/article/detail",
    component: () => import("@/pages/knowledge/articledetail")
  },
  {
    name: "设置孕育状态",
    path: "/maternal/breedstatus",
    component: () => import("@/pages/maternal/breedstatus"),
    meta: {
      systemCode: 'role'
    }
  },
  {
    name: "孕育知识",
    path: "/maternal/knowledgelist",
    component: () => import("@/pages/maternal/knowledgelist"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  }
];
/*maternalRouterMap.map((item, index) => {
  item.systemType = 'yunchan'
});*/
export default maternalRouterMap;
